import { render, staticRenderFns } from "./DeveloperNotes.vue?vue&type=template&id=5b7d1d84&"
import script from "./DeveloperNotes.vue?vue&type=script&lang=js&"
export * from "./DeveloperNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports